import type { ReactElement } from 'react';
import { ListItem, ListItemPrimaryText } from '@noah-labs/fe-shared-ui-components';
import type {
  MarkdownRemarkFrontmatterHeaderMenuHeaderLinks,
  Maybe,
} from '../../../generated/types';
import { NavigationItem } from '../menus/NavigationItem';
import { StyledListItemButton } from './DesktopMenuItem';
import { MobileMenuAccordion } from './MobileMenuAccordion';

type PpMobileMenuItem = {
  hasSublinks?: boolean;
  menuItem: Maybe<MarkdownRemarkFrontmatterHeaderMenuHeaderLinks>;
};

export function MobileMenuItem({ hasSublinks, menuItem }: PpMobileMenuItem): ReactElement | null {
  if (hasSublinks) {
    return (
      <MobileMenuAccordion summary={menuItem?.headerLabel}>
        {menuItem?.sublinks?.map((sublink) => {
          if (!sublink) {
            return null;
          }

          return (
            <StyledListItemButton
              key={sublink.sublinkLabel}
              component={NavigationItem}
              href={sublink.sublinkUrl}
            >
              <ListItemPrimaryText color="text.primary" variant="paragraphBodyS">
                {sublink?.sublinkLabel}
              </ListItemPrimaryText>
            </StyledListItemButton>
          );
        })}
      </MobileMenuAccordion>
    );
  }
  return (
    <ListItem>
      <StyledListItemButton component={NavigationItem} href={menuItem?.headerURL}>
        <ListItemPrimaryText color="text.primary" component="span" variant="subHeadingM">
          {menuItem?.headerLabel}
        </ListItemPrimaryText>
      </StyledListItemButton>
    </ListItem>
  );
}
